import { recordSentry } from "utils/recordSentry";

const enforceCharacterLimitAction = (actionsArray: string[], actionDataArray: string[]) => {
	const limitStringIndex = actionsArray.indexOf("CHARACTER_LIMIT");

	if (limitStringIndex === -1) {
		return undefined;
	}

	const limitString = actionDataArray[limitStringIndex];

	if (limitString === undefined || limitString === "") {
		return undefined;
	}
	let limit: number | undefined = undefined;
	try {
		limit = parseInt(actionDataArray[limitStringIndex]);
	} catch (error) {
		recordSentry({ error });
	}

	return limit;
};

export default enforceCharacterLimitAction;
